module.exports = __webpack_public_path__ + "static/media/AvSchool.3a9295c2.zip";